import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98e9575c")

_pushScopeId("data-v-98e9575c")
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "buttons flex justify-between" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_my_button = _resolveComponent("my-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "modal",
    visible: _ctx.basicVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.basicVisible = $event)),
    "confirm-loading": _ctx.basicLoading,
    centered: true,
    footer: null,
    onCancel: _ctx.onCancel,
    width: 468,
    zIndex: _ctx.zIndex
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "content"),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_my_button, {
            bgcolor: "orange",
            key: "submit",
            onClick: _ctx.onOk,
            loading: _ctx.basicLoading
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.okText), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_my_button, {
            bgcolor: "grey",
            onClick: _ctx.onCancel
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["visible", "confirm-loading", "onCancel", "zIndex"]))
})